export default __webpack_public_path__ + "assets/order-on-its-way-3-small.png";